<template lang="pug">
  .column.is-11
    data-notification(icon="attach_money" v-bind:loading="revenues.isLoading" type="is-success")
      p.title Faturamentos
      p.subtitle {{revenues.data}} {{revenues.data | pluralize('cadastrado')}} este mês
    article.card.table-card
      header.card-header
        p.card-header-title Faturamentos Emitidos a Vencer
      .card-content.is-paddingless
        b-table(
          v-bind:data="revenuesDue.data",
          v-bind:striped="true",
          v-bind:narrowed="false",
          v-bind:mobile-cards="false",
          v-bind:loading="revenuesDue.isLoading",
          v-bind:row-class="getRowClass"
        )
          template(slot-scope="props")
            b-table-column(label="Nome") {{props.row.name}}
            b-table-column(label="Tipo") {{props.row.type}}
            b-table-column(label="Valor") {{props.row.value | currency}}
            b-table-column(label="Data Vencimento" v-bind:class="{'has-text-danger': props.row.due_date <= today}") {{props.row.due_date | moment('DD/MM/YYYY')}}
            b-table-column(label="Status Análise")
              b-tag(v-bind:type="statusClass[props.row.payment.status]") {{ statusLabel[props.row.payment.status] }}
            b-table-column(centered label="Gerenciar Pagamento")
              b-tooltip(label="Alterar Pagamento do Faturamento" type="is-dark")
                router-link(v-bind:to="{name: 'paymentRevenueEdit', params: {id: props.row._id}}")
                  span &nbsp;&nbsp; #[b-icon(icon="edit" type="is-primary" size="is-small")]
          template(slot="empty")
            section.section
              .content.has-text-grey.has-text-centered
                p
                  b-icon(icon="sentiment_very_dissatisfied", size="is-large")
                p Nenhum dado.
</template>

<script>
  import DataNotification from './DataNotification'

  import RevenueService from '@/services/revenue.js'
  const {statusLabel, statusClass} = RevenueService

  export default {
    name: 'RevenuesDue',
    components: {DataNotification},
    data () {
      return {
        today: this.$moment().startOf('day').toISOString(),
        startOfMonth: this.$moment().startOf('isoMonth').toISOString(),
        revenuesDue: {isLoading: false, data: []},
        revenues: {isLoading: false, data: 0},
        statusLabel,
        statusClass
      }
    },
    async created () {
      this.fetchRevenues()
      this.fetchRevenuesDue()
    },
    methods: {
      getRowClass (row) {
        if (row.due_date <= this.today) return 'is-danger'
      },
      async fetchRevenues (params) {
        let query = {created_at: {$gte: this.startOfMonth}, limit: 1}
        query = Object.assign(query, params)
        this.revenues.isLoading = true
        const response = await RevenueService.query(query)
        this.revenues.isLoading = false
        this.revenues.data = response.body.meta.count
      },
      async fetchRevenuesDue (params) {
        let query = {payment: {paid: false, status: 'emitted'}, limit: 20, sort: {due_date: 'asc'}}
        query = Object.assign(query, params)
        this.revenuesDue.isLoading = true
        const response = await RevenueService.query(query)
        this.revenuesDue.isLoading = false
        this.revenuesDue.data = response.body.revenues
      }
    }
  }
</script>

<style lang="sass" scoped>
  .table-card
    min-height: 15rem
</style>



// WEBPACK FOOTER //
// RevenuesDue.vue?0c98ecb9